import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
// mui
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Select, MenuItem } from "@mui/material";
// component
import ButtonMain from "../../../../../../../../../../../common/components/button/ButtonMain";
import { StoreContext } from "../../../../../../../../../../../store/StoreProvider";
// img
import disabledArrowRight from "../../../../../../../../../../../../images/icon_arrow_right/icon_arrow_right.svg";
import arrowRight from "../../../../../../../../../../../../images/ai_image/arrow-right.svg";
import NoQuota from "../../../../../../component/NoQuota";

const models = [{ index: 0, label: "人物" }];
const MainRight = ({ handleFetch }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { InputTxt } = sna.AI;
  const { quota } = sna;
  const intl = useIntl();
  const [selectModel, setSelectModel] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (
      InputTxt.length === 0 ||
      InputTxt.length > 4000 ||
      selectModel === null
    ) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [InputTxt, selectModel]);

  return (
    <Grid
      container
      item
      xs
      sx={{
        marginLeft: "8px",
        backgroundColor: "#FFFFFF",
        padding: "16px 24px 24px 24px",
        borderRadius: "8px",
        boxShadow: "0 8px 16px 0 #096C9B1A",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "calc(100vh - 170px)",
      }}
    >
      <Grid>
        <Typography
          sx={{
            paddingBottom: "8px",
            fontWeight: "700",
            marginBottom: "16px",
          }}
        >
          {" "}
          {intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ai.selectModel.title",
            defaultMessage: "分析模型",
          })}
        </Typography>
        <Select
          fullWidth
          id="selectModel"
          value={selectModel}
          onChange={(event) => setSelectModel(event.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selectModel) {
              return (
                <p style={{ margin: 0, color: "#888888" }}>選擇分析模型</p>
              );
            }
            return selected;
          }}
        >
          {models.map((el) => (
            <MenuItem key={el.index} value={el.label}>
              {el.label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid sx={{ marginBottom: "0", width: "100%" }}>
        <ButtonMain
          buttonProps={{
            text: "下一步",
            fullWidth: true,
            onClick: () => {
              // 如果額度已滿，阻擋使用者
              if (quota.ai === true) {
                setIsOpen(true);
                return;
              }
              handleFetch(InputTxt);
              dispatch({
                type: "SNA_SET_AI_IS_FETCH_DATA",
                payload: true,
              });
              dispatch({
                type: "SNA_SET_AI_CURRENT_PAGE",
                payload: "result",
              });
            },
            variant:
              InputTxt.length === 0 ||
              InputTxt.length > 4000 ||
              selectModel === null
                ? "disableLinearGradient"
                : "linearGradient",
            endIcon: (
              <img
                src={btnDisabled ? disabledArrowRight : arrowRight}
                alt="icon_arrow_right"
              />
            ),
            disabled: btnDisabled,
          }}
        />
        <NoQuota isOpen={isOpen} closeFct={closeModal} />
      </Grid>
    </Grid>
  );
};

export default MainRight;

MainRight.propTypes = {
  handleFetch: PropTypes.func,
};
MainRight.defaultProps = {
  handleFetch: undefined,
};
